import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import FloorplanCard from "./FloorplanCard";
import { Button } from "@/components/ui/button";
import { useAutoFillViewport } from "@/hooks/useAutoFillViewport";
var FloorplanGrid = function (_a) {
    var onReset = _a.onReset, floorplans = _a.floorplans, hasNextPage = _a.hasNextPage, fetchNextPage = _a.fetchNextPage, isFetchingNextPage = _a.isFetchingNextPage, isFetchNextPageError = _a.isFetchNextPageError, error = _a.error, isError = _a.isError, isLoading = _a.isLoading, costEstimatorPropertyId = _a.costEstimatorPropertyId;
    useAutoFillViewport({
        enabled: floorplans.length > 0,
        itemCount: floorplans.length,
        hasNextPage: hasNextPage !== null && hasNextPage !== void 0 ? hasNextPage : false,
        isFetchingNextPage: isFetchingNextPage,
        fetchNextPage: fetchNextPage,
    });
    if (isLoading && floorplans.length === 0) {
        return (React.createElement("div", { className: "text-center py-6 text-xs" }, "Fetching floorplans..."));
    }
    if (isError && floorplans.length === 0) {
        return React.createElement("div", { className: "text-center py-6" },
            "\uD83D\uDEA8 ", error === null || error === void 0 ? void 0 :
            error.message);
    }
    if (floorplans.length === 0) {
        return (React.createElement("div", { className: "text-center py-12" },
            React.createElement("h3", { className: "text-lg font-semibold mb-2" }, "No Floorplans Found"),
            React.createElement("p", { className: "text-sm text-muted-foreground" },
                "Try adjusting your filters to see more results or",
                " ",
                React.createElement("button", { onClick: onReset, className: "text-primary hover:underline focus:outline-none" }, "reset filters to see all floorplans"))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(InfiniteScroll, { dataLength: floorplans.length, next: fetchNextPage, hasMore: hasNextPage !== null && hasNextPage !== void 0 ? hasNextPage : false, loader: React.createElement("div", { className: "text-center py-6" }, "Loading more...") },
            React.createElement("div", { className: "grid w-full grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" }, floorplans.map(function (floorplan) { return (React.createElement(FloorplanCard, { key: floorplan.id, floorplan: floorplan, costEstimatorPropertyId: costEstimatorPropertyId })); }))),
        isFetchNextPageError && (React.createElement("div", { className: "text-center py-4 text-sm text-destructive" },
            "Could not load more floor plans.",
            " ",
            React.createElement("button", { type: "button", onClick: function () { return fetchNextPage(); }, className: "text-primary hover:underline focus:outline-none" }, "Try again"))),
        hasNextPage && !isFetchingNextPage && (React.createElement("div", { className: "text-center py-6" },
            React.createElement(Button, { variant: "outline", onClick: function () { return fetchNextPage(); } }, "Load more floor plans")))));
};
export default FloorplanGrid;
